/**
 * Configuration API
 */

export const API_CONFIG = {
  baseURL: import.meta.env.VITE_API_URL ?? 'http://localhost:8100',
  timeout: 30000, // 30 seconds
};

const WS_BASE = import.meta.env.VITE_API_URL != null && import.meta.env.VITE_API_URL !== ''
  ? import.meta.env.VITE_API_URL.replace(/^http/, 'ws')
  : import.meta.env.VITE_API_URL === ''
    ? `ws${location.protocol === 'https:' ? 's' : ''}://${location.host}`
    : 'ws://localhost:8100';

export const API_ENDPOINTS = {
  // Auth
  login: '/auth/login',
  refresh: '/auth/refresh',
  me: '/auth/me',
  logout: '/auth/logout',

  // Patients
  patients: '/patients',
  patient: (id: string) => `/patients/${id}`,

  // Observations + Traçabilités
  observations: '/api/v1/observations',
  observation: (id: string) => `/api/v1/observations/${id}`,
  observationValider: (id: string) => `/api/v1/observations/${id}/valider`,
  tracabilites: '/api/v1/tracabilites',
  tracabilite: (id: string) => `/api/v1/tracabilites/${id}`,

  // Séjours
  sejours: '/api/v1/sejours',
  sejourActif: (patientId: string) => `/api/v1/patients/${patientId}/sejour-actif`,
  sejourTerminer: (id: string) => `/api/v1/sejours/${id}/terminer`,

  // Voice WebSocket
  voiceWs: (token: string) => `${WS_BASE}/ws/voice?token=${token}`,
  wakewordWs: (token: string) => `${WS_BASE}/ws/wakeword?token=${token}`,

  // Demo PMSI
  demoPmsi: '/demo/pmsi',

  // DPI live (POC vocal — US-VDPI-02/06) : vue fusionnée référence + saisies + journal
  dpi: '/api/v1/dpi',

  // DPI dialogue guidé (POC vocal — US-VDPI-02/03)
  dpiChambre: (numero: string) => `/api/v1/dpi/chambres/${encodeURIComponent(numero)}`,
  dpiMenu: (patientId: string) => `/api/v1/dpi/patient/${encodeURIComponent(patientId)}/menu`,
  dpiSaisie: '/api/v1/dpi/saisie',

  // Project management (internal — ADMIN + CADRE uniquement)
  projectAgents: '/api/v1/internal/project/agents',

  // Admin — gestion utilisateurs (ADMIN uniquement)
  adminUsers: '/admin/users',
  adminUser: (id: string) => `/admin/users/${id}`,

  // Core E-5 — Jobs + HITL + Traces + Policy (US-113..117)
  jobs: '/api/v1/internal/jobs',
  jobsHitl: '/api/v1/internal/jobs/hitl',
  jobsHitlApprove: (id: string) => `/api/v1/internal/jobs/${id}/approve`,
  jobsHitlReject: (id: string) => `/api/v1/internal/jobs/${id}/reject`,
  jobStatus: (id: string) => `/api/v1/internal/jobs/${id}/status`,
  traces: (jobId: string) => `/api/v1/internal/traces?job_id=${jobId}`,
  context: '/api/v1/internal/context',
  contextGet: (jobId: string) => `/api/v1/internal/context/${jobId}`,
  policy: '/api/v1/internal/policy',
  policyByType: (acteType: string) => `/api/v1/internal/policy/${acteType}`,
  adminTraces: '/api/v1/internal/admin/traces',
  adminTracesByJob: (jobId: string) => `/api/v1/internal/admin/traces?job_id=${jobId}`,

  // Vision/RPA — E-6 (US-131..135)
  // Vision/RPA admin (JWT) — E-6
  rpaAdminAnalyze: (screenName: string) => `/api/v1/internal/rpa/admin/analyze?screen_name=${encodeURIComponent(screenName)}`,
  rpaAdminCaptures: '/api/v1/internal/rpa/admin/captures',
  rpaAdminGuardrail: '/api/v1/internal/rpa/admin/guardrail',

  // Action Engine — E-10 (US-145)
  actionEngineMetrics: '/api/v1/internal/action-engine/metrics',

  // Agents platform — E-13 (config, prompts, versioning, actions)
  agentConfig: (agentId: string) => `/api/v1/internal/agents/${agentId}/config`,
  agentPrompts: (agentId: string, taskType?: string) =>
    `/api/v1/internal/agents/${agentId}/prompts${taskType ? `?task_type=${taskType}` : ''}`,
  agentPromptsActive: (agentId: string) => `/api/v1/internal/agents/${agentId}/prompts/active`,
  agentPromptActivate: (agentId: string, promptId: string) =>
    `/api/v1/internal/agents/${agentId}/prompts/${promptId}/activate`,
  agentActions: (agentId: string, limit = 20) =>
    `/api/v1/internal/agents/${agentId}/actions?limit=${limit}`,
  agentMode: (agentId: string) => `/api/v1/internal/agents/${agentId}/mode`,
};
